import {Validators} from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type DetailsState from "../detailsState";

export const SET_CUSTOMER_PHONE = "SET_CUSTOMER_PHONE";

export class SetCustomerPhone extends Action<typeof SET_CUSTOMER_PHONE, number> {
  readonly type = SET_CUSTOMER_PHONE;
  protected state: DetailsState;

  constructor(state: DetailsState, phone?: number | undefined) {
    super(state, phone);
    this.state = state;
  }
  /**
   * Business logic:
   * This action is only doable for Private Customers.
   * After it has been set it is also still possible to set it again.
   *
   * @returns boolean: true if doable
   */
  public isDoable(): boolean {
    return true;
  }

  /**
   * Confirms a phoneNumber is isValid
   * @returns boolean: true if valid
   */
  public isValid(): boolean {
    const phoneNumber = this.data;
    const isPhoneNumberValid = Validators.phoneNumberValidator(phoneNumber);
    return isPhoneNumberValid && this.isDoable();
  }
}
